const answerhidden = (state = [], action) => {
    switch (action.type) {
      case 'ADD_ANSWER_HIDDEN':
        return {
            type: "ADD_ANSWER_HIDDEN",
            idatendimento: action.idatendimento,
            cliente: action.cliente,
            telefone: action.telefone,
            servico: action.servico,
            datatimeatd: action.datatimeatd,
            menubot: action.menubot,
            criticidade: action.criticidade,
            subservico: action.subservico,
            id: action.id,
            serviceatd: action.serviceatd,
            recuperation: action.recuperation,
            recuperationtime: action.recuperationtime,
            respatendente: action.respatendente,
            respclient: action.respclient,
            direction: action.direction,
            idmidia: action.idmidia,
            timecomplete: action.timecomplete,
            statusagent: action.statusagent,
            line: action.line,
            statusatd: action.statusatd,
            queueid: action.queueid,
            serverid: action.serverid,
            qtdmessage: action.qtdmessage,
            pathfile: action.pathfile,
            mcdu:action.mcdu,
            nomesubservico:action.nomesubservico,
            infoinitcall: action.infoinitcall,
            nomecliente:action.nomecliente,
            protocolo: action.protocolo,
            datatachado: state.datatachado !== undefined ? state.datatachado:"",
            idsubservico: action.idsubservico,
            acw: action.acw,
            isDialNc2: action.isDialNc2,
            arrayChannels: action.arrayChannels !== undefined ? action.arrayChannels:[],
            caseId: action.caseId,
            score_class: action.score_class,
            score_value: action.score_value,
            nps_call: action.nps_call
        }      
      case 'REMOVE_ANSWER_HIDDEN':
        return [];
      default:
        return state
    }
  }
  
  export default answerhidden